module.exports = require("./dist/angular-validation-match.min.js");


//////////////////
// WEBPACK FOOTER
// angular-validation-match (bower component)
// module id = 418
// module chunks = 0